import React, { useEffect } from 'react';

import useMediaQuery from 'hooks/useMediaQuery';
import useMounted from 'hooks/useMounted';

import { createGlobalState } from './hookGlobalState';
import TabNavOrganisation from './TabNavOrganisation';

const MAX_HORIZONTAL_NAV_SCREEN_WIDTH = 1023;

const initialScrollState = { scrollLeft: 0 };
const { useGlobalState } = createGlobalState(initialScrollState);

const scrollToTab = (currentPage, scrollLeft, setScrollLeft) => {
  const el = document.querySelector(`#${currentPage}Tab`);

  if (el) {
    const parent = el.parentElement;
    const parentRect = parent.getBoundingClientRect();
    const maxScrollDistance = parent.scrollWidth - parentRect.width;

    const hasParentScrolled = parent.scrollLeft > 0;
    const scrollPositionCurrent = hasParentScrolled ? parent.scrollLeft : scrollLeft;

    const tabRect = el.getBoundingClientRect();
    const diffLeftBetweenTabAndParent = tabRect.left - parentRect.left;
    const tabScrollPosition = parent.scrollLeft + diffLeftBetweenTabAndParent;

    const scrollPositionNew =
      tabScrollPosition > maxScrollDistance
        ? maxScrollDistance
        : parent.scrollLeft + diffLeftBetweenTabAndParent;

    const needsSmoothScroll = scrollPositionCurrent !== scrollPositionNew;

    if (parent.scrollTo && (!hasParentScrolled || (hasParentScrolled && needsSmoothScroll))) {
      parent.scrollTo({ left: scrollPositionCurrent });
      parent.scrollTo({ left: scrollPositionNew, behavior: 'smooth' });
    }
    setScrollLeft(scrollPositionNew);
  }
};

const LayoutWrapperOrganisationSideNav = (props) => {
  const mounted = useMounted();
  const [scrollLeft, setScrollLeft] = useGlobalState('scrollLeft');
  const hasHorizontalTabLayout = useMediaQuery(
    `(max-width: ${MAX_HORIZONTAL_NAV_SCREEN_WIDTH}px)`,
    true
  );

  const { currentPage } = props;

  useEffect(() => {
    if (hasHorizontalTabLayout && mounted) {
      scrollToTab(currentPage, scrollLeft, setScrollLeft);
    }
  }, [currentPage, hasHorizontalTabLayout, scrollLeft, setScrollLeft, mounted]);

  return <TabNavOrganisation currentPage={currentPage} />;
};

export default LayoutWrapperOrganisationSideNav;
